import { render, staticRenderFns } from "./AssignmentStakeholderList.vue?vue&type=template&id=9d10e31a&scoped=true&"
import script from "./AssignmentStakeholderList.vue?vue&type=script&lang=js&"
export * from "./AssignmentStakeholderList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentStakeholderList.vue?vue&type=style&index=0&id=9d10e31a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d10e31a",
  null
  
)

export default component.exports